import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  font-size: var(--font-title-size);
  justify-content: flex-end;
  align-items: center;
  position: relative;
  z-index: 999;
  color: #000 !important;
  -webkit-tap-highlight-color: transparent;

  svg {
    color: #000 !important;
    ${(props) => !props.inline && "position: absolute;"}
    margin-right: 0.5rem;
  }

  :hover {
    cursor: pointer;
  }
`;

export const Polygon = styled.div`
  position: absolute;
  width: 8px;
  height: 8px;
  left: 114px;
  top: 51px;

  background: #ffffff;
  transform: rotate(180deg);
`;

export const Frame = styled.div`
  position: absolute;
  /* transform: opacity(2) !important; */
  background-color: #fff;
  padding: 0.2rem;
  border: 0.5px solid #cecece;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  font-weight: normal;
  font-size: var(--font-inscricao);
  margin-top: -70px;
  z-index: 100;
  line-height: 14px;
  width: 123px;
  -webkit-tap-highlight-color: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  div {
    position: absolute;
    padding: 0;
    margin: 0;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  span {
    color: #000 !important;
  }

  @media screen and (min-width: 900px) {
    line-height: 16px;
    width: auto;
    text-align: center;
    margin-left: 8rem;
    font-size: 14px;
    width: 200px;

    span {
      padding: 1rem;
    }
  }
`;
